import styled from 'styled-components'

export const Buttons = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: end;
  gap: 16px;
  button {
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
  }
  .cancel {
    height: 40px;
    background-color: #f0f0f0 !important;
    border-color: #f0f0f0 !important;
    color: #4c4c4c !important;
    padding: 12px;
    border-radius: 8px;
  }
  .reset {
    height: 40px;
    border-radius: 8px;
    color: white !important;
    background-color: #0085ff !important;
    &:hover {
      background-color: #0069f2 !important;
    }
    &:disabled {
      opacity: 0.48;
    }
  }
`
